'use strict'

module.exports = require('./types')
